import React, { useState, useEffect } from 'react';
import { useProjectDropList } from 'hooks/queries/common/commonDropListQuery';
import {
  usePackageList,
  usePackageServerUpdate,
  usePackageUpdate,
} from 'hooks/queries/package/packageQuery';
import { IPackageProps } from 'utils/types/pacakageTypes';
import DefaultButton from 'components/button/DefaultButton';
import H3Title from 'components/etc/H3Title';
import CheckboxOneType from 'components/input/CheckboxOneType';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import TwoRowTable from 'components/table/TwoRowTable';
import HeaderSection from 'components/container/HeaderSection';
import { useTranslation } from 'react-i18next';
/**
 * * 패키지 관리 - 앱 > 기본정보
 *
 *
 */

interface IProps {
  appInformation: IPackageProps;
}
const AppInformationView = ({ appInformation }: IProps) => {
  const { t } = useTranslation();
  const [updateTypeName, setUpdateTypeName] = useState<string>('');
  const [detailData, setDetailData] = useState<IPackageProps>();

  const { data: packageList } = usePackageList();
  const { data: projectDropList } = useProjectDropList();
  const { mutate: packageUpdate } = usePackageUpdate();
  const { mutate: packageServerUpdate } = usePackageServerUpdate();

  const handleClick = (e) => {
    if (updateTypeName === 'cancel') {
      setUpdateTypeName('');
    } else {
      setUpdateTypeName(e.target.name);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;

    setDetailData({ ...detailData!, [name]: value });
    if (name === 'require_hash_check') {
      setDetailData({ ...detailData!, [name]: checked ? 1 : 0 });
    }
  };
  const handleSelectChange = (val, option) => {
    setDetailData({
      ...detailData!,
      project_id: val,
      project_name: option.children,
    });
  };

  const handleInformationSubmit = () => {
    setUpdateTypeName('');
    packageUpdate({ detailData });
  };

  const handleServerSubmit = () => {
    setUpdateTypeName('');
    packageServerUpdate({ detailData });
  };
  useEffect(() => {
    if (appInformation || packageList) {
      packageList?.map(
        (v) => v.package_id === appInformation?.package_id && setDetailData(v),
      );
    }
    // setDetailData(appInformation);
  }, [packageList]);
  return (
    <>
      <HeaderSection>
        <>
          <H3Title>
            {t(
              'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.header.title',
            )}
          </H3Title>
          <div>
            {(updateTypeName === '' || updateTypeName === 'server') && (
              <DefaultButton name='information' onClick={handleClick}>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.header.updateButton',
                )}
              </DefaultButton>
            )}

            {updateTypeName === 'information' && (
              <>
                <DefaultButton name='' onClick={handleClick}>
                  {t(
                    'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.header.cancelButton',
                  )}
                </DefaultButton>
                <DefaultButton name='' onClick={handleInformationSubmit}>
                  {t(
                    'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.header.saveButton',
                  )}
                </DefaultButton>
              </>
            )}
          </div>
        </>
      </HeaderSection>
      <TwoRowTable>
        <tbody>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.table.packageID',
              )}
            </th>
            <td>{detailData?.package_id}</td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.table.bundleID',
              )}
            </th>
            <td>
              {updateTypeName === 'information' ? (
                <DefaultInput
                  name='bundle_id'
                  value={detailData?.bundle_id}
                  onChange={handleInputChange}
                  bottom='false'
                />
              ) : (
                detailData?.bundle_id
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.table.packageID',
              )}
            </th>
            <td>
              {updateTypeName === 'information' ? (
                <DefaultInput
                  name='install_url'
                  value={detailData?.install_url}
                  onChange={handleInputChange}
                  bottom='false'
                />
              ) : (
                detailData?.install_url
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.table.projectName',
              )}
            </th>
            <td>
              {updateTypeName === 'information' ? (
                <DefaultSelect
                  name='project_id'
                  value={detailData?.project_id}
                  optionList={projectDropList}
                  onChange={handleSelectChange}
                  bottom='false'
                />
              ) : (
                detailData?.project_name
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.basicInformation.table.requireHashCheck',
              )}
            </th>
            <td>
              <CheckboxOneType
                name='require_hash_check'
                disabled={updateTypeName === 'information' ? false : true}
                checked={detailData?.require_hash_check === 1 ? true : false}
                onChange={handleInputChange}
              />
            </td>
          </tr>
        </tbody>
      </TwoRowTable>
      <HeaderSection style={{ marginTop: '3.5rem' }}>
        <>
          <H3Title>
            {t(
              'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.header.title',
            )}
          </H3Title>
          <div>
            {(updateTypeName === '' || updateTypeName === 'information') && (
              <DefaultButton name='server' onClick={handleClick}>
                {t(
                  'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.header.updateButton',
                )}
              </DefaultButton>
            )}
            {updateTypeName === 'server' && (
              <>
                <DefaultButton name='' onClick={handleClick}>
                  {t(
                    'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.header.cancelButton',
                  )}
                </DefaultButton>
                <DefaultButton name='' onClick={handleServerSubmit}>
                  {t(
                    'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.header.saveButton',
                  )}
                </DefaultButton>
              </>
            )}
          </div>
        </>
      </HeaderSection>

      <TwoRowTable>
        <tbody>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.table.testServerURL',
              )}
            </th>
            <td>
              {updateTypeName === 'server' ? (
                <DefaultInput
                  name='test_server_url'
                  value={detailData?.test_server_url}
                  onChange={handleInputChange}
                  bottom='false'
                />
              ) : (
                detailData?.test_server_url
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.table.reviewServerURL',
              )}
            </th>
            <td>
              {updateTypeName === 'server' ? (
                <DefaultInput
                  name='review_server_url'
                  value={detailData?.review_server_url}
                  onChange={handleInputChange}
                  bottom='false'
                />
              ) : (
                detailData?.review_server_url
              )}
            </td>
          </tr>
          <tr>
            <th>
              {t(
                'packageIDAppInformation.tabs.appContents.tabPane.appInformationContens.serverInformation.table.liveServerURL',
              )}
            </th>
            <td>
              {updateTypeName === 'server' ? (
                <DefaultInput
                  name='live_server_url'
                  value={detailData?.live_server_url}
                  onChange={handleInputChange}
                  bottom='false'
                />
              ) : (
                detailData?.live_server_url
              )}
            </td>
          </tr>
        </tbody>
      </TwoRowTable>
    </>
  );
};

export default AppInformationView;
